import { Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectApp: React.FC = () => {
  const navigate = useNavigate();

  const deepLink = 'ministeriobelem://';
  useEffect(() => {
    const fallbackUrl = '/instalar-app';

    window.location.href = deepLink;

    const timeoutId = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        navigate(fallbackUrl);
      }
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <Stack height="100vh" alignItems="center" justifyContent="center">
      <h2>Redirecionando...</h2>
      <p>
        Se você não for redirecionado automaticamente,{' '}
        <a href={deepLink}>clique aqui</a>.
      </p>
    </Stack>
  );
};

export default RedirectApp;
